<template>
  <div>
    <FeedbackModal
      @closeFeedbackModal="feedbackState = { shown: false }"
      class="new-modals"
      :feedbackState="feedbackState"
      :localeService="localeService"
      :presentationId="renderParams.config.presentationId"
    />
    <section>
      <PersonalOffer
        :localeService="localeService"
        :presentationId="renderParams.config.presentationId"
      />
      <div class="container">
        <div class="row offers">
          <div
            :class="`col-lg-9 col-xl-9 ${
              (!renderParams.agent && 'mx-auto') || ''
            }`"
          >
            <Offer
              v-for="(lead, leadIdx) of leads"
              :class="leadIdx === leads.length - 1 && 'last-offer'"
              :key="lead.id"
              :lead="lead"
              :localeService="localeService"
              :version="version"
              :renderParams="renderParams"
              @showFeedback="onShowFeedback"
            />
            <HotLinks
              :localeService="localeService"
              :isAgent="renderParams.agent"
              :isInfractructure="renderParams.config.isInfrastructure"
              :presentationId="renderParams.config.presentationId"
              :isMap="renderParams.map"
              :leadsIds="leads.map((l) => l.id)"
            />
          </div>
          <PersonalAgent
            :localeService="localeService"
            :renderParams="renderParams"
            :version="version"
            :location="'right'"
            class="col-lg-3 col-xl-3"
          />
        </div>
      </div>
      <PersonalAgent
        :localeService="localeService"
        :renderParams="renderParams"
        :version="version"
        :location="'bottom'"
        class="agent-mobile d-none d-sm-flex align-items-center d-lg-none"
      />
    </section>
  </div>
</template>

<script>
import 'bootstrap/dist/css/bootstrap.css'
import { ref } from 'vue'
import FeedbackModal from './FeedbackModal.vue'
import PersonalOffer from '../common/PersonalOffer.vue'
import Offer from './Offer/Offer.vue'
import HotLinks from './HotLinks.vue'
import PersonalAgent from '../common/PersonalAgent.vue'
import Locale from '../../../services/locale'
import { metrikaEvents } from '../../../services/metrika'

export default {
  name: 'Standard',
  props: {
    renderParams: Object,
    version: String,
    localeService: Locale,
  },
  components: {
    FeedbackModal,
    PersonalOffer,
    Offer,
    HotLinks,
    PersonalAgent,
  },
  setup() {
    const feedbackState = ref({
      shown: false,
    })

    return {
      feedbackState,
    }
  },
  methods: {
    onShowFeedback(state) {
      metrikaEvents.onOpenFeedback()
      this.feedbackState = {
        ...this.feedbackState,
        ...state,
      }
    },
  },
  computed: {
    leads() {
      return this.renderParams.leads
    },
  },
}
</script>

<style scoped>
@import '../../../assets/style.css';
</style>

<style>
body.presentation-standard-view {
  background-color: #f9f9f9;
}

@media (max-width: 767px) {
  .new-modals {
    display: block !important;
  }
  .feedback-modal {
    width: 90vw !important;
    position: relative;
    margin-left: auto;
    margin-right: auto;
    top: 25vh;
  }
}

.new-modals {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgb(57 53 53 / 71%);
}
@media (max-width: 991px) {
  body.presentation-standard-view .price {
    padding-top: 7px;
  }
}
</style>
